var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.073 21.444h7.886M14.041 28.783H37.96M14.041 36.123H37.96M14.041 43.462H37.96M24.073 23.244H12.547V20.88c0-2.7 2.188-4.888 4.888-4.888h1.75c2.7 0 4.888 2.188 4.888 4.888v2.364z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.31,
    cy: 10.001,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.323 14.575H37.96M33.65 2H9.201a2.15 2.15 0 00-2.15 2.15v43.7A2.15 2.15 0 009.202 50h33.596a2.15 2.15 0 002.15-2.15V13.3a2.15 2.15 0 00-.63-1.52l-9.149-9.15A2.15 2.15 0 0033.65 2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.5f2433bdd724e0c13654ada384729d92.svg";
export { ForwardRef as ReactComponent };